import { QueryParams } from '../types/QueryParams';

export function getQueryParams(): QueryParams {
  const queryString = window.location.search.slice(1);
  if (!queryString) {
    return {};
  }

  return queryString.split('&').reduce(
    (map, pairString) => {
      const pairArray = pairString.split('=');
      map[pairArray[0]] = decodeURIComponent(pairArray[1] ?? '');
      return map;
    },
    {} as { [key: string]: string }
  );
}

export function getReferrer() {
  const queryParams = getQueryParams();
  return queryParams.referrer;
}
